// extracted by mini-css-extract-plugin
export default {"root":"FilterPlain_root__UR18Q","clearButton":"FilterPlain_clearButton__+fkAJ h5","plain":"FilterPlain_plain__xg19V","isOpen":"FilterPlain_isOpen__uD61R"};